import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import styles from '../index.scss';

const PromoButton = ({
  promotionApplied,
  isPromoCodeInputVisable,
  onToggleShowPromoCodeInput,
  handleRemovePromoCode
}) => {
  const renderButton = () => {
    if (isPromoCodeInputVisable) {
      return null;
    }

    if (promotionApplied) {
      return (
        <>
          <button
            className={`btn btn-link ${styles.actionButton}`}
            onClick={handleRemovePromoCode}
            type="button"
          >
            {I18n.t(
              'strava.subscriptions.checkout.summary.organic.promo_code.cta.remove'
            )}
          </button>
          <span className={styles.actionDivider}>·</span>
        </>
      );
    }
    return (
      <>
        <button
          className={`btn btn-link ${styles.actionButton}`}
          onClick={onToggleShowPromoCodeInput}
          type="button"
        >
          {I18n.t(
            'strava.subscriptions.checkout.summary.organic.promo_code.cta.enter'
          )}
        </button>
        <span className={styles.actionDivider}>·</span>
      </>
    );
  };

  return renderButton();
};

PromoButton.propTypes = {
  promotionApplied: PropTypes.bool.isRequired,
  isPromoCodeInputVisable: PropTypes.bool.isRequired,
  onToggleShowPromoCodeInput: PropTypes.func.isRequired,
  handleRemovePromoCode: PropTypes.func.isRequired
};

export default PromoButton;
